var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-menu',{staticClass:"navbar",attrs:{"mode":"horizontal"}},[_c('hamburger',{staticClass:"hamburger-container",attrs:{"toggle-click":_vm.toggleSideBar,"is-active":_vm.sidebar.opened}}),_c('breadcrumb')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }